<p-table [value]="groups" [scrollable]="true" scrollHeight="50vh" selectionMode="single" #table
    [(selection)]="selectedGroup" dataKey="id" [globalFilterFields]="['name']">

    <ng-template pTemplate="header">
        <tr class="hidden">
            <th class="w-3rem"></th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="caption">
        <div class="flex justify-items-center">

            <span class="p-input-icon-left mr-auto">
                <i class="far fa-magnifying-glass"></i>
                <!-- TODO: wird hier target.value gebraucht, oder reicht target aus? -->
                <input pInputText type="text" (input)="table.filterGlobal($event.target['value'], 'contains')"
                    placeholder="Search" i18n-placeholder="@@profile-picker-groups.search.placeholder" />
            </span>
            <div> <p-button label="Accept" i18n-label="@@profile-picker-groups.dialog.buttons.accept"
                (onClick)="onAcceptGroup()" [disabled]="selectedGroup==null" class="ml-2" severity="secondary"></p-button></div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td i18n="@@profile-picker-groups.fields-table.empty">No groups found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-group let-index="rowIndex">
        <tr class="mb-2">
            <td>
                <p-tableRadioButton [value]="group"></p-tableRadioButton>
            </td>
            <td>
                <div class="mb-1">{{group.name}} ({{group.numberOfMembers}})</div>

            </td>
        </tr>
        <tr>
            <td class="spacer-row" [colSpan]="12"></td>
          </tr>
    </ng-template>
</p-table>
